import { ModulesMap } from '@/config/data/modulesMaps'
import InfrastructureTagsApi from '@/services/apiServiceModules/infrastructureTagsApi'
import DataTransferModule from '@/services/dataTransferModule'

const infrastructureTagsApi = new InfrastructureTagsApi()

export default class InfrastructureTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.INFRASTRUCTURE_TAGS, infrastructureTagsApi, {
			useCache: true,
		})
	}
}
